import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import OursourcesCard from '../components/OursourcesCard';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

export default class OutsourcesScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MIS_SUBCONTRATAS')} breadcrumbs={breadcrumbs}>
                <OursourcesCard title={I18nUtils.tr('TR_TODAS_LAS_SUBCONTRATAS')} limitPage={12}/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/outsource/screens/OutsourcesScreen.js